import moment from 'moment';
import 'moment/locale/fr';

moment.locale('fr');

export const useMoment = () => {
    const formatAgo = (date: string | Date): string => {
        const mDate = moment(date);

        if (mDate.isSame(moment(), 'day')) {
            return mDate.fromNow();
        }

        if (mDate.isSame(moment().subtract(1, 'day'), 'day')) {
            return `Hier à ${mDate.format('HH:mm')}`;
        }

        const diffDays = moment().diff(mDate, 'days');
        const diffMonths = moment().diff(mDate, 'months');
        const diffYears = moment().diff(mDate, 'years');

        if (diffDays < 30) {
            return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
        }

        if (diffMonths < 12) {
            return `Il y a ${diffMonths} mois`;
        }

        return `Il y a ${diffYears} an${diffYears > 1 ? 's' : ''}`;
    };

    const formatDate = (date: string | Date): string => {
        return moment(date).format('DD/MM/YYYY');
    };

    return {
        formatAgo,
        formatDate
    };
};
